import { FC, ReactNode } from 'react';

import { Counter, Icon } from '@beeline/design-system-react/extracted-styles';
import { Icons } from '@beeline/design-tokens/js/iconfont';

import classes from './BottomSheetTitle.module.scss';

export interface BottomSheetTitleProps {
  title: ReactNode;
  filtersCount: number;
}

export const BottomSheetTitle: FC<BottomSheetTitleProps> = ({
  title,
  filtersCount,
}) => {
  return (
    <div className={classes.container}>
      {title}
      <Counter count={filtersCount ? filtersCount : undefined} size='small'>
        <div className={classes.filters}>
          <Icon iconName={Icons.Filter} />
        </div>
      </Counter>
    </div>
  );
};
